import defaultRestApi from "../common/RestApiInstance";
import APIs from "../common/APIs";
import querystring from 'query-string';

export default class LandingPageServices {

    static fetchBanners = (params) => {
        return defaultRestApi.get(APIs.fetchBanner(querystring.stringify(params)),
        {
            headers: {
              "Content-Type": "application/json"
            }
        });
    }

    static fetchOdds = (params) => {
        return defaultRestApi.get(APIs.fetchOdds(querystring.stringify(params).replace(/%2C/g,",")),
        {
            headers: {
              "Content-Type": "application/json"
            }
        });
    }

    static fetchSideBanners = (params) => {
        return defaultRestApi.get(APIs.fetchSideBanner(querystring.stringify(params)),
        {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/app/services/LandingPageServices.js